import { APP_VERSION } from "utils/const";

export const getCurrentVersion = () => {
  return +APP_VERSION || 0;
}
